import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';
import { Link } from 'react-router-dom';
import DataTable from "react-data-table-component";

const PendingConfirmations = () => {
  const [orders, setOrders] = useState([]);
  const [confirming, setConfirming] = useState({});
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#39465c",
        color: "white",
        fontWeight: "bold",
        fontSize: "15px",
      },
    },
    cells: {
      style: {
        padding: "8px",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        minHeight: "45px",
        '&:hover': {
          backgroundColor: "#f1f1f1",
        }
      },
    },
  };

  useEffect(() => {
    axios.get('https://sunrise-backend.sunrisemeditechsystems.com/api/orders/pending/confirmation', { headers: { Authorization: `Bearer ${getToken()}` } })
      .then(res => {
        setOrders(res.data);
      })
      .catch(err => {
        console.error('Error fetching pending confirmations:', err);
      });
  }, []);

  const confirmOrder = (orderId) => {
    setConfirming(c => ({ ...c, [orderId]: true }));
    axios.post(`https://sunrise-backend.sunrisemeditechsystems.com/api/orders/${orderId}/confirm`, {}, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then(() => {
        setConfirming(c => ({ ...c, [orderId]: false }));
        setOrders(orders => orders.filter(order => order.id !== orderId));
      });
  };

  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Customer",
      selector: row =>      
        row.source === "sunrise-website"
          ? `${row.shipping_address?.firstName || "Guest"} ${
              row.shipping_address?.lastName || ""
            }`
          : `${row.shipping_address?.doctorName || "Doctor"} - ${
              row.shipping_address?.hospitalName || "Hospital"
            }`,
      wrap: true,
      sortable: true,
    },
    {
      name: "Placed By",
      selector: (row) => row.placed_by,
      sortable: true,
    },
    {
      name: "Confirm",
      cell: (row) => (
        <button
          className="btn btn-success btn-sm"
          onClick={() => confirmOrder(row.id)}
          disabled={confirming[row.id]}
        >
          {confirming[row.id] ? "Confirming..." : "Confirm"}
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active">Pending Confirmations</li>
                  </ol>
                </div>
                <h4 className="page-title">Pending Confirmations</h4>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              {orders.length === 0 ? (
                <div className="text-center py-5">
                  <i className="mdi mdi-bell-ring-outline mdi-48px text-muted"></i>
                  <h5 className="mt-3">No Orders Needing Confirmation</h5>
                  <p className="text-muted">There are no orders pending admin confirmation.</p>
                </div>
              ) : (
                <div className="table-responsive">
                  {/* <table className="table table-centered table-hover mb-0">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Customer</th>
                        <th>Placed By</th>
                        <th>Confirm</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map(order => (
                        <tr key={order._id}>
                          <td>{order._id.slice(-6).toUpperCase()}</td>
                          <td>{order.user?.name || '-'}</td>
                          <td>{order.placedBy}</td>
                          <td>
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => confirmOrder(order._id)}
                              disabled={confirming[order._id]}
                            >
                              {confirming[order._id] ? 'Confirming...' : 'Confirm'}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table> */}
                  <div style={{ width: "50%" }}>
                    <DataTable
                      // title="Orders"
                      columns={columns}
                      data={orders}
                      highlightOnHover
                      striped
                      responsive
                      pagination
                      customStyles={customStyles}
                      defaultSortFieldId="date"  // sort by Date column
                      defaultSortAsc={false}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingConfirmations;
